import { api } from "./client";

export const repoApi = {
  list: (includeInactive = false) =>
    api.get(`/codebase/repos`, { params: { include_inactive: includeInactive } }),

  get: (repoId) => api.get(`/codebase/repos/${repoId}`),

  create: (payload) => api.post(`/codebase/repos`, payload),

  update: (repoId, payload) => api.put(`/codebase/repos/${repoId}`, payload),

  deactivate: (repoId) => api.delete(`/codebase/repos/${repoId}`),

  testConnection: (repoId, connection_token) =>
    api.post(`/codebase/repos/${repoId}/test-connection`, {
      connection_token
    })
};
